var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2081_38521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9995 0.0126953C9.24255 0.0126962 9.48108 0.0792786 9.68981 0.205385C9.89853 0.331492 10.0697 0.512424 10.1851 0.729014H10.1851L17.8101 14.9853C17.9215 15.1931 17.9776 15.4267 17.973 15.6631C17.9684 15.8995 17.9032 16.1306 17.7838 16.3338C17.6644 16.537 17.4948 16.7053 17.2918 16.8222C17.0889 16.939 16.8594 17.0004 16.6259 17.0004L1.37307 17.0004V17.0004C1.13977 17.0005 0.910457 16.9392 0.70757 16.8226C0.50457 16.7059 0.334996 16.5378 0.215462 16.3347C0.0959279 16.1317 0.0305279 15.9007 0.0256811 15.6644C0.0208352 15.4281 0.0766992 15.1945 0.187805 14.9866L0.187937 14.9864L7.79879 0.759073C7.80356 0.748977 7.80858 0.738944 7.81387 0.729014C7.92931 0.512424 8.10046 0.331491 8.30919 0.205385C8.51791 0.0792774 8.75645 0.0126953 8.9995 0.0126953ZM8.99968 1.37866L1.3727 15.6361H16.626C16.6259 15.6359 16.6258 15.6357 16.6257 15.6356L9 1.37802C8.99989 1.37823 8.99979 1.37845 8.99968 1.37866ZM8.32584 10.1786V6.08551C8.32584 5.70875 8.62745 5.40333 8.9995 5.40333C9.37154 5.40333 9.67315 5.70875 9.67315 6.08551V10.1786C9.67315 10.5554 9.37154 10.8608 8.9995 10.8608C8.62745 10.8608 8.32585 10.5554 8.32584 10.1786Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0112 13.2479C10.0112 13.5193 9.90473 13.7795 9.71523 13.9714C9.52573 14.1633 9.26871 14.2712 9.00071 14.2712C8.73272 14.2712 8.4757 14.1633 8.2862 13.9714C8.0967 13.7795 7.99023 13.5193 7.99023 13.2479C7.99023 12.9765 8.0967 12.7162 8.2862 12.5243C8.4757 12.3324 8.73272 12.2246 9.00071 12.2246C9.26871 12.2246 9.52573 12.3324 9.71523 12.5243C9.90473 12.7162 10.0112 12.9765 10.0112 13.2479Z",
    fill: "#7E7E7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2081_38521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSvgrepoCom1);
export default __webpack_public_path__ + "static/media/warning-svgrepo-com 1.f14a7dcf787cf6cf4f7f61ef7175229c.svg";
export { ForwardRef as ReactComponent };